import Navbar from "@/components/landing/Navbar";
import Mandamientos from "@/components/landing/Mandamientos";
import MethodIntro from "@/components/landing/MethodIntro";
import Challenge from "@/components/landing/Challenge";
import Solution from "@/components/landing/Solution";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import PowerQuote from "@/components/landing/PowerQuote";
import ClosingCTA from "@/components/landing/ClosingCTA";
import CalendlySection from "@/components/landing/CalendlySection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

const MandamientosPage = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <Mandamientos />
      <MethodIntro />
      <Challenge />
      <Solution />
      <AboutUs />
      <Stats />
      <Testimonials />
      <PowerQuote />
      <ClosingCTA />
      <CalendlySection />
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default MandamientosPage;
